import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { Property } from "@app/models/Property";
import { OauthService } from "@app/services/oauth.service";
import { SpinnerService } from "@app/services/spinner.service";
import { PropertiesService } from "@app/services/properties.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { UserStore } from "@app/services/stores/UserStore";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { PropertyComponent } from "@app/components/property/property.directive";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-property-landing',
    imports: [PropertyComponent],
    template: require('./propertylanding.html')
})
export class PropertyLandingComponent implements OnInit {
    properties: Property[] = [];
    property: Property;
    doneLoading: boolean;

    constructor(
        @Inject(WindowToken) private window,
        @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
        @Inject(OauthService) private oauthService: OauthService,
        @Inject(SpinnerService) private SpinnerService: SpinnerService,
        @Inject(PropertiesService) private PropertiesService: PropertiesService,
        @Inject(NetworkErrorService) private NetworkErrorService: NetworkErrorService,
        @Inject(PaymentStore) private PaymentStore: PaymentStore,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute) {}

    ngOnInit() {

        this.SpinnerService.closeSpinner();
        this.doneLoading = false;
        this.refreshProperties();
        this.PaymentStore.clearAll();
    }

    addProperty() {
        this.router.navigateByUrl('/properties/add');
    }

    refreshProperties() {
        this.SpinnerService.showSpinner();
        let userId = this.userStore.getHoaHomeownerId();
        if (userId) {
            // Get the properties by userId
            try {
                this.homeownerApi.homeownersIdPropertiesGet(userId)
                    .pipe(take(1)).subscribe((data) => {
                        this.properties = data;
                        this.PropertiesService.updateProperties(this.properties);
                        if(this.properties.length > 1) {
                            this.properties.sort((x, y) => x.propertyGroupId - y.propertyGroupId)
                        }
                        this.SpinnerService.closeSpinner();
                        this.doneLoading = true;
                    }, err => {
                        this.NetworkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                this.doneLoading = true;
                                if (resp === true) {
                                    this.refreshProperties();
                                }
                            })
                    });
            } catch(err) {
                this.NetworkErrorService.handleNetworkError(err, true)
                    .pipe(take(1)).subscribe((resp) => {
                        this.doneLoading = true;
                        if (resp === true) {
                            this.refreshProperties();
                        }
                    })
            }
        }
    }
}

